import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, arraysAreEqual } from "../CommonComponents/CustomHooks";
import { FormButton } from "../CommonComponents/InputBox";
import { OperationalTable } from "../CommonComponents/OperationalTable";

const UnDispatch = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [scanNo, setScanNo] = useState('')
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [CheckAll, setCheckAll] = useState(false)
    const [tableData, setTableData] = useState([])
    const [formData, setFormData] = useState({
        manifestNoList: []
    });

    const handleUnDispatch = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/UnDispatchEntry', { manifestNo: (formData.manifestNoList).toString() })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    }

    const handleClear = () => {
        setFormData({
            manifestNoList: []
        })
        UnDispatchDetails()
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const UnDispatchDetails = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetUnDispatchDetail', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }


    const handleCheck = (id, awbNo) => {
        const updatedManifestNoList = [...formData.manifestNoList];
        const index = updatedManifestNoList.indexOf(awbNo);

        if (index !== -1) {
            updatedManifestNoList.splice(index, 1);
        } else {
            updatedManifestNoList.push(awbNo);
        }
        setFormData({ ...formData, manifestNoList: updatedManifestNoList });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = tableData?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setTableData(prevCNResult => ({
            ...prevCNResult,
            Data: updatedTableData
        }));
        const updatedManifestNoList = value ? tableData?.Data.map(item => item.ManifestNo) : [];
        setFormData({
            ...formData, manifestNoList: updatedManifestNoList,
        });
    };

    const HandleScanData = async () => {
        if (!scanNo) {
            await NotificationSound('ERROR', 'Please enter Awb No.!', 'txtAwbNo', inputrefs);
            return;
        } else {
            let isAvaialble = tableData?.Data?.filter(item => item.ManifestNo === scanNo).length;
            if (isAvaialble) {
                let tableData1 = tableData.Data.map(item => {
                    if (scanNo === item.ManifestNo && item.checkStatus === false) {
                        return {
                            ...item,
                            checkStatus: true
                        }
                    } else {
                        return {
                            ...item,
                            checkStatus: item.checkStatus ? item.checkStatus : false
                        }
                    }
                })
                setScanNo('')
                const updatedList = tableData1?.filter(item => item.checkStatus).map(item => item.ManifestNo) || [];
                setFormData({ ...formData, manifestNoList: [...updatedList] })
            } else {
                setScanNo('')
                await NotificationSound('ERROR', 'ManifestNo Not Found!', 'txtAwbNo', inputrefs);
                return;
            }
        }
    }
    const handleChange1 = (event, value) => {
        UnDispatchDetails(value);
    };
    useEffect(() => {
        let newTableData = tableData?.Data?.map(item => {
            const checkStatus = formData?.manifestNoList?.some(awb => item.ManifestNo === awb) ? true : false;
            return { ...item, checkStatus };
        });
        if (!arraysAreEqual(newTableData, tableData.Data)) {
            setTableData(CNResult => ({
                ...tableData, Data: newTableData,
                HideColumns: CNResult?.HideColumns ? [...CNResult?.HideColumns, 'checkStatus'] : ['checkStatus']
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.Data, formData.manifestNoList]);

    useEffect(() => {
        document.title = 'Un-Dispatch'
    }, []);
    useEffect(() => {
        UnDispatchDetails();
    }, [sortConfig])
    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 pb-3 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <span className="fs-6 fw-bold headingspan"> { FindTranslatedKey('Un-Dispatch')}</span>
                    </div>
                    <div className='card-body pb-1'>
                        <FormButton
                            Export={false}
                            handleSubmit={handleUnDispatch}
                            handleClear={handleClear}
                        />
                    </div>
                    <OperationalTable
                        PageName={'UnDispatch'}
                        inputPlaceHolder='Manifest No.'
                        showCheckBox={true}
                        Filter={false}
                        loading={isLoading}
                        handleCheck={handleCheck}
                        handleCheckAll={handleCheckAll}
                        CheckAll={CheckAll}
                        tableData={tableData}
                        currentPageNo={currentPageNo}
                        cnNo={scanNo}
                        setcnNo={setScanNo}
                        HandleScanList={HandleScanData}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                        handleChange1={handleChange1 }
                    />
                </div>
            </div>
        </>
    )
}
export default UnDispatch;